import { ORTHO_TEETH_LIST } from 'consts/teethConsts'

export const sortTeeth = (teeth = []) =>
  teeth.sort((t1, t2) => ORTHO_TEETH_LIST.indexOf(t1) - ORTHO_TEETH_LIST.indexOf(t2))
